export function SvgIcon({ d, size = 18, strokeWidth = 2 }: { d: string; size?: number; strokeWidth?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
      <path d={d} />
    </svg>
  );
}

export function CameraIcon({ size = 18 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
      <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
      <circle cx="12" cy="13" r="4" />
    </svg>
  );
}

export function UploadIcon({ size = 48 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="17 8 12 3 7 8" />
      <line x1="12" y1="3" x2="12" y2="15" />
    </svg>
  );
}

export function XIcon({ size = 20 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  );
}

export function AlertIcon({ size = 48 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
  );
}

export function ArrowLeftIcon() {
  return <svg width={18} height={18} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>;
}

export function ArrowRightIcon() {
  return <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7" /></svg>;
}

export function UserIcon({ size = 16 }: { size?: number }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>;
}

export function ShoppingBagIcon({ size = 16 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
      <path d="M16 10a4 4 0 0 1-8 0" />
      <path d="M3.103 6.034h17.794" />
      <path d="M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z" />
    </svg>
  );
}

export function SearchIcon({ size = 16 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.5-3.5" />
    </svg>
  );
}

export function ExternalLinkIcon({ size = 16 }: { size?: number }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><path d="M14 3h7v7" /><path d="M10 14 21 3" /><path d="M21 14v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5" /></svg>;
}

export function ClockIcon({ size = 16 }: { size?: number }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>;
}

export function RulerIcon({ size = 18 }: { size?: number }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><path d="M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z" /><path d="m14.5 12.5 2-2" /><path d="m11.5 9.5 2-2" /><path d="m8.5 6.5 2-2" /><path d="m17.5 15.5 2-2" /></svg>;
}

export function SparkleIcon({ size = 18 }: { size?: number }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" /></svg>;
}

export function TrashIcon({ size = 14 }: { size?: number }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /></svg>;
}

export function ChevronRightIcon() {
  return <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>;
}

export function ChevronDownIcon({ size = 18 }: { size?: number }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.4} strokeLinecap="round" strokeLinejoin="round"><path d="m6 9 6 6 6-6" /></svg>;
}

export function CheckIcon({ size = 14 }: { size?: number }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>;
}

export function GlobeIcon({ size = 16 }: { size?: number }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><path d="M2 12h20" /><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" /></svg>;
}

/* ── Garment icons for multi-section tuxedo/suit cards ── */

export function CoatIcon({ size = 32 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 30" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      {/* Jacket body */}
      <path d="M1 29L1 10L7 3L12 6L17 3L23 10L23 29Z" />
      {/* Center seam */}
      <line x1="12" y1="18" x2="12" y2="29" />
      {/* Left lapel */}
      <path d="M7 3L1 10L10 19L12 17" />
      {/* Right lapel */}
      <path d="M17 3L23 10L14 19L12 17" />
      {/* Sleeve seam left */}
      <path d="M1 10L3 22" strokeWidth="1" />
      {/* Sleeve seam right */}
      <path d="M23 10L21 22" strokeWidth="1" />
      {/* Breast welt pocket */}
      <line x1="3" y1="14" x2="8" y2="14" strokeWidth="2" />
      {/* Left hip flap pocket */}
      <path d="M2 23L9 22L9 25L2 25" />
      {/* Right hip flap pocket */}
      <path d="M15 22L22 23L22 25L15 25" />
      {/* Single button */}
      <circle cx="12" cy="21" r="1" fill="currentColor" />
    </svg>
  );
}

export function PantsIcon({ size = 32 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 30" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      {/* Waistband */}
      <rect x="2" y="2" width="20" height="3" rx="0.5" />
      {/* Belt buckle */}
      <rect x="10" y="2.5" width="4" height="2" rx="0.3" />
      {/* Hips to crotch */}
      <path d="M2 5L2 12L12 14L22 12L22 5" />
      {/* Left leg */}
      <path d="M2 12L2 27L11 27L12 14" />
      {/* Right leg */}
      <path d="M22 12L22 27L13 27L12 14" />
      {/* Left cuff */}
      <line x1="2" y1="25" x2="11" y2="25" />
      {/* Right cuff */}
      <line x1="13" y1="25" x2="22" y2="25" />
      {/* Left crease */}
      <line x1="6.5" y1="14" x2="6" y2="25" strokeWidth="1" strokeDasharray="2 1.5" />
      {/* Right crease */}
      <line x1="17.5" y1="14" x2="18" y2="25" strokeWidth="1" strokeDasharray="2 1.5" />
    </svg>
  );
}

export function VestIcon({ size = 32 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 30" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      {/* Vest body — narrower than jacket */}
      <path d="M4 29L4 10L8 3L12 7L16 3L20 10L20 29Q12 31 4 29Z" />
      {/* Armhole curves */}
      <path d="M4 10Q2 14 2 18" strokeWidth="1" />
      <path d="M20 10Q22 14 22 18" strokeWidth="1" />
      {/* Left lapel */}
      <path d="M8 3L4 10L11 19L12 17" />
      {/* Right lapel */}
      <path d="M16 3L20 10L13 19L12 17" />
      {/* 4 buttons */}
      <circle cx="12" cy="19" r="0.8" fill="currentColor" />
      <circle cx="12" cy="22" r="0.8" fill="currentColor" />
      <circle cx="12" cy="25" r="0.8" fill="currentColor" />
      <circle cx="12" cy="28" r="0.8" fill="currentColor" />
      {/* Welt pockets */}
      <line x1="5" y1="21" x2="10" y2="21" />
      <line x1="14" y1="21" x2="19" y2="21" />
    </svg>
  );
}

export function ShirtIcon({ size = 32 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
      <path d="M8 2l-5 5 3 2 2-3v14h8V6l2 3 3-2-5-5" />
      <path d="M8 2h8" />
      <path d="M12 6v3" />
    </svg>
  );
}

export function BowTieIcon({ size = 32 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 6l7 6-7 6V6z" />
      <path d="M20 6l-7 6 7 6V6z" />
      <rect x="10.5" y="10" width="3" height="4" rx="1" />
    </svg>
  );
}

export function ShoesIcon({ size = 32 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 18h18v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-1z" />
      <path d="M3 18c0-3 1-5 3-7l2-1.5V6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2h3l3 2c2 1.5 3 4 3 8" />
    </svg>
  );
}

/** Map a section name (from backend) to the appropriate garment icon */
export function GarmentIcon({ name, size = 32 }: { name: string; size?: number }) {
  const n = name.toLowerCase();
  if (n.includes("pant") || n.includes("trouser") || n.includes("pantalon")) return <PantsIcon size={size} />;
  if (n.includes("vest") || n.includes("waistcoat") || n.includes("gilet")) return <VestIcon size={size} />;
  if (n.includes("shirt") || n.includes("camicia") || n.includes("chemise") || n.includes("camisa")) return <ShirtIcon size={size} />;
  if (n.includes("bow") || n.includes("tie") || n.includes("cravat") || n.includes("papillon")) return <BowTieIcon size={size} />;
  if (n.includes("shoe") || n.includes("scarpe") || n.includes("chaussure") || n.includes("zapato")) return <ShoesIcon size={size} />;
  if (n.includes("coat") || n.includes("jacket") || n.includes("blazer") || n.includes("giacca") || n.includes("veste") || n.includes("sakko")) return <CoatIcon size={size} />;
  // Default: coat icon for unknown garment pieces
  return <CoatIcon size={size} />;
}
